import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
interface Props {
  sidebar: ReactNode;
  header: ReactNode;
  children: ReactNode;
}
export function PlpLayout(t0) {
  const $ = _c(10);
  const {
    sidebar,
    header,
    children
  } = t0;
  let t1;
  if ($[0] !== sidebar) {
    t1 = <aside aria-label="Filters" className="hidden w-full shrink-0 lg:block lg:w-[320px]" data-testid="plp-layout-sidebar">{sidebar}</aside>;
    $[0] = sidebar;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="flex w-full min-w-0 flex-1 flex-col gap-3">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col items-start gap-6 lg:flex-row">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== header || $[8] !== t3) {
    t4 = <div className="mx-auto flex w-full max-w-site-content flex-col gap-6 px-6 py-6" data-testid="plp-layout">{header}{t3}</div>;
    $[7] = header;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}